import React from 'react';
import { Chip, Spinner, Tooltip } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes, IProjectPreviewJson } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';
import moment from 'moment';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';

const ProjectPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: project,
    loading,
    error,
  } = useObjectPreview<IProjectPreviewJson>(id, INamedObjectTypes.Project);
  const { isRemoAdmin } = useRemoAdminCtx();
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;
  return (
    <div className="project-preview">
      <style jsx>{`
        .project-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: flex-start;
        }

        .project-preview__thing-list > div {
          display: flex;
        }

        .project-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      <div className="project-preview__banner">
        <Chip label={project?.taskType} />
        <h3 style={{ margin: '0 5px' }}>{project?.name}</h3>
      </div>
      <div className="project-preview__body">
        <div className="project-preview__thing-list">
          <div>
            <strong>Delivery Portal</strong>
            <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/qm/queue/${id}`}>
              {id}{' '}
            </IsomorphicLink>
          </div>
          <div>
            <strong>Permission Group</strong>
            <IsomorphicLink
              target="_blank"
              rel="noopener noreferrer"
              href={`/lookup/${project?.permissionGroup?._id}`}
            >
              {project?.permissionGroup?.name}{' '}
            </IsomorphicLink>
          </div>
          {!isRemoAdmin && (
            <div>
              <strong>Task Customer</strong>
              <IsomorphicLink
                target="_blank"
                rel="noopener noreferrer"
                href={`/lookup/${project?.taskCustomer?._id}`}
              >
                {project?.taskCustomer?.email}{' '}
              </IsomorphicLink>
            </div>
          )}
          {!!project?.createdAt && (
            <div>
              <strong>Created</strong>
              <Tooltip placement={'top'} title={new Date(project?.createdAt).toLocaleString()}>
                <span>{moment(project?.createdAt).fromNow()}</span>
              </Tooltip>
            </div>
          )}
          {!!project?.qaaasFor && (
            <div>
              <strong>QaaaS Project For</strong>
              <IsomorphicLink
                target="_blank"
                rel="noopener noreferrer"
                href={`/qm/queue/${project?.qaaasFor}`}
              >
                {project?.qaaasFor}{' '}
              </IsomorphicLink>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectPreview;
